import React from "react";
import "./ResumeView.scss";
import ProductAuthorService from "../../../services/content/ProductAuthorService";
import { ResumeViewIProps, ResumeViewIState } from "./ResumeView.models";
import Avatar from "../../../assest/images/card-image/ItemAvatarInfo.png";

export default class ResumeView extends React.PureComponent<ResumeViewIProps, ResumeViewIState> {
  productAuthorService: ProductAuthorService;
  constructor(props: any) {
    super(props);
    this.productAuthorService = new ProductAuthorService();
    this.state= {
    }
  }

  componentDidMount() {
    if(this.props.assistantUserId !== null && this.props.assistantUserId !== undefined && this.props.assistantUserId !== '')
      this.getAssistantDetail()
    else if (this.props.authorId !== null && this.props.authorId !== undefined )
      this.getAuthorDetail()
  }

  componentDidUpdate(prevProps: any) {
    if(this.props.authorId !== prevProps.authorId && this.props.authorId !== null && this.props.authorId !== undefined)
      this.getAuthorDetail()
    else if(this.props.assistantUserId !== prevProps.assistantUserId && this.props.assistantUserId !== null && this.props.assistantUserId !== undefined )
      this.getAssistantDetail()
  }

  getAssistantDetail(){
    let self = this;
    let props = this.props;

    if (props.assistantUserId !== null && props.assistantUserId !== undefined){
      self.productAuthorService
      .getAssistantDetailByUserId(props.assistantUserId)
      .then((response) => {
          self.setState({
            productAuthor: {
              authorHistory :response.authorHistory,
              displayName: response.displayName,
              authorImage: response.authorImage,
              isMyAdvisor: response.isMyAdvisor,
              userId: response.userId
            }
          });
      });
    }
  }

  getAuthorDetail(){
    let self = this;
    let props = this.props;

    if (props.authorId !== null && props.authorId !== undefined){
      self.productAuthorService
        .getDetailByAuthorId(props.authorId)
        .then((response) => {
          self.setState({
            productAuthor: response,
          });
        });
    }
  }

  render(): React.ReactNode {
    let { productAuthor } = this.state;
    let content;

    if (productAuthor != null) {
      if (this.props.assistantUserId === null || this.props.assistantUserId === undefined || this.props.assistantUserId === '') {
        content = (
          <>
            <div className="col-12  margin-top-large">
              <div className="tk-card">
                <div className="col-12" style={{ padding: "10px" }}>
                  <div className="tk-inline">
                    <div className="col-12 notspace">
                      <div className="title-resume">
                        <label>شهرت {productAuthor.displayName}</label>
                        <span className="subTitle">
                          {productAuthor.authorFame}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      }
    } else {<></>}

    return (
      <>
      {productAuthor != null?
        <div className="dropdown-list resume-area">
          {content}
           <div className="col-12  margin-top-large">
             <div className="tk-card">
               <div className="card-icon">
                 <img src={Avatar} width="58px" alt="" />
               </div>
               <div className="card-title">
                 <label>سوابق {productAuthor.displayName}</label>
               </div>
               <div className="col-12 page-info">
                 <div className="tk-inline">
                   <label
                     className="card-subTitle"
                     dangerouslySetInnerHTML={{
                       __html: productAuthor.authorHistory,
                     }}
                   ></label>
                 </div>
               </div>
             </div>
         </div>
        </div>: <></>}
      </>
    );
  }
}
